import React from 'react';
import Highlight from '../Highlight/Highlight.jsx';

const SearchSuggestionsNosto = ({
    query,
    suggestions,
    handleSuggestionClick,
}) => {
    const formatSuggestion = (text) => {
        return text.replace(/_/g, ' - ');
    };

    // Handle suggestion click with search tracking
    const handleSuggestionClickWithAttribution = (suggestion) => {
        // Record keyword click tracking as per Nosto docs: https://docs.nosto.com/techdocs/implementing-nosto/implement-search/search#keyword-click-tracking
        if (typeof window !== 'undefined' && window.nostojs) {
            window.nostojs((api) => {
                // Create the search request object for the keyword suggestion
                const searchRequest = {
                    query: suggestion,
                    products: {
                        fields: ['name', 'productId', 'url', 'imageUrl', 'price', 'listPrice', 'brand'],
                        size: 0 // No products expected for keyword suggestion
                    }
                }

                // Create empty search result since this is a keyword suggestion click
                const searchResult = {
                    products: {
                        hits: [],
                        total: 0,
                        size: 0,
                        from: 0
                    }
                }

                // Record keyword search tracking without chaining (API doesn't return a promise)
                try {
                    api.recordSearch(
                        'autocomplete',
                        searchRequest,
                        searchResult,
                        {
                            isKeyword: true
                        }
                    );
                    console.log('🔍 Keyword search tracking recorded:', { suggestion });
                } catch (error) {
                    console.error('❌ Keyword search tracking error:', error);
                }
            });
        }

        // Call the original handler to perform the search
        handleSuggestionClick(suggestion);

        console.log('🔍 Keyword clicked, stored for SERP tracking:', { suggestion });
    };

    return (
        <div className='flyout-section flyout-section-outer suggestions-section mt-1 mb-4 font-akkurat'>
            <div className='flyout-section-inner'>
                <h3 className='flyout-section-title text-web-s3-section-content font-bold mb-1 md:mb-2'>
                    Suggestions
                </h3>
                {suggestions && suggestions.length > 0 ? (
                    <ul className='suggestions-list nostyle grid grid-cols-2 md:grid-cols-1 gap-1 md:gap-2'>
                        {suggestions.map((suggestion, index) => (
                            <li
                                key={index}
                                className='py-1'
                            >
                                <button
                                    className='font-akkurat hover:underline cursor-pointer w-full text-left truncate block'
                                    onClick={() => handleSuggestionClickWithAttribution(suggestion)}
                                >
                                    <Highlight search={query}>
                                        {formatSuggestion(suggestion)}
                                    </Highlight>
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className='no-results'>
                        <p className='font-normal text-flint text-sm'>
                            No suggestions found
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchSuggestionsNosto;
